import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import "../Style/Header.css";
import { selectUser } from "../Features/userSlice";
import { fade, makeStyles } from "@material-ui/core/styles";
import Drawer from "./Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";

import db, { auth } from "../firebase";
import { Avatar } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: "darkgray",
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    color: "#fc6347",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "darkgray",
  },
  inputRoot: {},
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "60ch",
    },
    justifyContent: "center",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
    color: "darkgray",
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    color: "darkgray",
  },
  paper: {
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    zIndex: "10",
    outline: "0",
    position: "absolute",
    maxWidth: "calc(100% - 32px)",
    minWidth: "16px",
    maxHeight: "calc(100% - 32px)",
    minHeight: "16px",
    overflowX: "hidden",
    overflowY: "auto",
  },
}));

export default function PrimarySearchAppBar({ searchHandler, categoryFilter }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElTwo, setAnchorElTwo] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const user = useSelector(selectUser);
  const history = useHistory();
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);

  const isNotificationsOpen = Boolean(anchorElTwo);
  const id = isNotificationsOpen ? "simple-popper" : undefined;

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleClick = (event) => {
    setAnchorElTwo(anchorElTwo ? null : event.currentTarget);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  //ToDo - need to make a mobile version

  const handleNotificationMenuClose = () => {
    setAnchorElTwo(null);
  };

  useEffect(() => {
    let mounted = true;
    if (user) {
      let unsub = db
        .collection("notifications")
        .where("user.askerUserId", "==", user.uid)
        .orderBy("timestamp", "desc")
        .onSnapshot((snapshot) => {
          if (mounted) {
            setNotifications(
              snapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
                content: doc.data().content,
              }))
            );
            setNotificationCount(
              snapshot.docs.filter((doc) => doc.data().seen === false).length
            );
          }
        });
      return () => {
        unsub();
      };
    }
  });

  const markNotificationsAsSeen = () => {
    if (user) {
      db.collection("notifications")
        .where("user.askerUserId", "==", auth.currentUser.uid)
        .where("seen", "==", false)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            for (const doc of querySnapshot.docs) {
              doc.ref.update({ seen: true });
            }
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    }
  };

  const routeChange = () => {
    let path = "/login";
    history.push(path);
  };

  const handleLogout = (e) => {
    e.preventDefault();

    user ? auth.signOut() : routeChange();
  };

  const avatarMenuId = "primary-search-account-menu";
  const avatarRenderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={avatarMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        onClick={handleMenuClose}
        onClick={handleLogout}
        src={user ? user.photo : Avatar}
      >
        Login / Logout
      </MenuItem>
      {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
    </Menu>
  );

  const notifificationMenuId = "primary-notification-menu";
  const notificationRenderMenu = (
    <Menu
      anchorElTwo={anchorElTwo}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      id={notifificationMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={isNotificationsOpen}
      onClose={handleNotificationMenuClose}
    >
      <MenuItem onClick={handleNotificationMenuClose}>
        <ul>
          {notifications.map((notification) => (
            <li key={notification.id}>{notification.content}</li>
          ))}
        </ul>
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton
          aria-label="show 17 new notifications"
          color="inherit"
          onClick={markNotificationsAsSeen}
        >
          <Badge
            color="secondary"
            badgeContent={notificationCount}
            overlap="circle"
            color="primary"
          >
            <NotificationsIcon
              aria-describedby={id}
              type="button"
              onClick={handleClick}
            />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls={avatarMenuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static" className="header">
        <Toolbar className="header__toolbar">
          <div className={classes.sectionMobile}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="open drawer"
            >
              <Drawer categoryFilter={categoryFilter} />
            </IconButton>
          </div>
          <Typography className={classes.title} variant="h6" noWrap>
            BuildFaast
          </Typography>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              className="header__toolbarSearchInput"
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
              onChange={searchHandler}
            />
          </div>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              aria-label="show notifications"
              aria-controls={notifificationMenuId}
              color="inherit"
              onClick={markNotificationsAsSeen}
            >
              <Badge
                color="secondary"
                badgeContent={notificationCount}
                overlap="circle"
                color="primary"
              >
                <NotificationsIcon
                  aria-describedby={id}
                  type="button"
                  onClick={handleClick}
                />
              </Badge>
            </IconButton>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={avatarMenuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {avatarRenderMenu}
      {notificationRenderMenu}
    </div>
  );
}
